import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_DETAIL = createActionType("ADD_DETAIL");
export const GET_DETAILS = createActionType("GET_DETAILS");
export const GET_DETAIL_BY_ID = createActionType("GET_DETAIL_BY_ID");
export const EDIT_DETAIL = createActionType("EDIT_DETAIL");
export const REMOVE_DETAIL = createActionType("REMOVE_DETAIL");

export const addDetail = (data: any) =>
    createAsyncAction(
        ADD_DETAIL,
        "/page_detaile/add_page_detaile",
        "post",
        data,
        {
            Authorization: `Bearer ${Cookies.get("token")}`,
        }
    );

export const getDetails = () =>
    createAsyncAction(
        GET_DETAILS,
        "/page_detaile/get_page_detailes",
        "get",
        undefined
    );

export const getDetailById = (data: any) =>
    createAsyncAction(
        GET_DETAIL_BY_ID,
        `/page_detaile/get_page_by_id/${data}`,
        "get",
        undefined
    );

export const editDetail = (id: any, data: any) =>
    createAsyncAction(
        EDIT_DETAIL,
        `/page_detaile/edit_page_detaile/${id}`,
        "put",
        data,
        {
            Authorization: `Bearer ${Cookies.get("token")}`,
        }
    );

export const removeDetail = (data: any) =>
    createAsyncAction(
        REMOVE_DETAIL,
        `/page_detaile/remove_page_detaile_by_id/${data}`,
        "delete",
        undefined,
        {
            Authorization: `Bearer ${Cookies.get("token")}`,
        }
    );
